import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Trans } from 'react-i18next';
import styles from './styles.module.scss';
export default function ListPreloader(props) {
    return (React.createElement("div", { className: styles.loaderWrap },
        React.createElement(Spin, { tip: props.tip || React.createElement(Trans, { i18nKey: "loadingDotted" }), indicator: React.createElement(LoadingOutlined, { style: { fontSize: 24 }, spin: true }), className: styles.loader })));
}
